import * as React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {MenuItemContainer} from '../../system/menu';
import {Action, Copy, Help, Secondary} from '../../system/buttons';
import PulsoidClient from '../../PulsoidClient';
import {Alert, FormControl} from 'react-bootstrap';
import {useEffect, useState} from 'react';
import {FeatureDisabler, TOKENS} from '../../system/FeatureDisabler';
import {TokenFeatureDescription} from '../../system/FeatureDescriptionModal';
import {PremiumWrapper} from '../PremiumWrapper';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';

export class Keys extends React.Component {
  client = new PulsoidClient();
  state = {
    tokens: [],
  };

  populateTokens = () =>
    this.client
      .getSelfCreatedAccessTokens()
      .then((res) => this.setState({tokens: res.tokens}));

  componentDidMount() {
    this.populateTokens();
  }

  render() {
    return (
      <MenuItemContainer title={'Tokens'}>
        <FeatureDisabler feature={TOKENS}>
          <Row style={{borderBottom: '1px solid #eee'}}>
            <Col md={7}>
              <h2>
                Tokens <TokenFeatureDescription />
              </h2>
            </Col>
          </Row>
          <PremiumWrapper bi={{from: 'keys'}}>
            <Row>
              <Col>
                {this.state.tokens.map((token, index) => (
                  <Row className={'pt-2'} key={index}>
                    <Col md={3}>{token.alias}</Col>
                    <Col md={5}>
                      <Revealable value={token.token} />
                    </Col>
                    <Col>
                      <Secondary
                        onClick={async () => {
                          await this.client.revokeAccessToken(token.token);
                          await this.populateTokens();
                        }}
                      >
                        Revoke
                      </Secondary>
                    </Col>
                  </Row>
                ))}
                <Row>
                  <Col>
                    <CreateTokenModal
                      client={this.client}
                      onTokenAdded={() => this.populateTokens()}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </PremiumWrapper>
        </FeatureDisabler>
      </MenuItemContainer>
    );
  }
}

const Revealable = ({value}) => {
  const [v, setV] = useState('***************************');

  return (
    <Row>
      <Col>
        <FormControl aria-describedby="basic-addon1" value={v} readOnly />
      </Col>
      <Col md={'3'} className={'d-flex justify-content-end'}>
        <Copy text={value} title={'Copy token'} />
      </Col>
      <Col md={'auto'}>
        <Help
          variant="outline-secondary"
          onClick={() => {
            if (v === value) {
              setV('***************************');
            } else {
              setV(value);
            }
          }}
        >
          Reveal
        </Help>
      </Col>
    </Row>
  );
};

const CreateTokenModal = ({client, onTokenAdded}) => {
  const generateAlias = () =>
    'pulsoid-token-' + Math.floor(1000 + Math.random() * 9000) + '';
  const [show, setShow] = useState(false);
  const [alias, setAlias] = useState();
  const [aliasError, setAliasError] = useState(null);
  useEffect(() => setAliasError(null), [alias]);
  useEffect(() => setAlias(generateAlias()), []);

  return (
    <>
      <Action onClick={() => setShow(true)}>Create new token</Action>
      <Modal size={'lg'} show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <h2>Create new token</h2>
        </Modal.Header>
        <Modal.Body>
          <Form.Group as={Row}>
            <Form.Label column md="5">
              Alias (short, recognizable name)
            </Form.Label>
            <Col>
              <FormControl
                type={'input'}
                value={alias}
                onChange={(e) => {
                  setAlias(e.target.value);
                }}
              />
            </Col>
          </Form.Group>
          {aliasError && (
            <Row>
              <Col>
                <Alert variant={'warning'}>{aliasError}</Alert>
              </Col>
            </Row>
          )}
          <Row className={'justify-content-md-end'}>
            <Col md={'auto'}>
              <Action
                onClick={() => {
                  if (alias && alias.length < 3) {
                    setAliasError('Alias length should be more than 3.');
                  } else if (alias && alias.length > 20) {
                    setAliasError('Alias length should be less than 20.');
                  } else {
                    client.createAccessToken(alias).then(() => {
                      setShow(false);
                      setAlias(generateAlias());
                      onTokenAdded();
                    });
                  }
                }}
              >
                Create
              </Action>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};
